module.exports = __webpack_public_path__ + "static/media/shoes1.2a0712a0.jpg";